export default {
  ALL: 'ALL',
  MIDROLL: 'MIDROLL',
  OVERLAY: 'OVERLAY',
  PAUSE: 'PAUSE',
  POSTROLL: 'POSTROLL',
  PREROLL: 'PREROLL',
};
